import { createFileRoute } from "@tanstack/react-router";
import { TimelinePage } from "@/features/timeline/timeline-page";

export const Route = createFileRoute("/app/w/$weddingId/timeline")({ component: TimelinePage });
